import useTypedSelector from '../../../common/hook/useTypedSelector';
import {HomeTabPage} from '../type';

export default function useRankingInfo() {
  const [tabs, talkBoards, selectedTabId] = useTypedSelector(state => [
    state.main.ranking.tabs,
    state.main.ranking.talkBoards,
    state.home.secondTabs[HomeTabPage.Main].selected,
  ]);
  const {
    adminSectionList = [],
    rankingList,
    rankingSectionTitle,
    isRankingInProgress,
    placement,
  } = tabs.find(item => item.id === selectedTabId) ?? {};
  const {bigContent, contents = []} = rankingList ?? {};
  const talkBoard = talkBoards?.find(
    item => item?.placement === `ad_${placement?.replace('top_', '')}`
  );

  return {
    tabs,
    bigContent,
    contents,
    talkBoard,
    selectedTabId,
    isRankingInProgress,
    rankingSectionTitle,
    adminSectionList,
    placement,
  };
}
